import React, { useState, useEffect } from 'react';
import { API_URL } from '../../utils/api';
import { fetchAvatarsBulk } from '../../utils/avatars';
import { fetchCountriesBulk } from '../../utils/countries';
import { formatNumber } from '../../utils/formatters';
import SteamAvatar from '../common/SteamAvatar';
import SteamFlag from '../common/SteamFlag';
import './Leaderboard.css';

const Leaderboard = ({ title, statType, icon, onSelectPlayer }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/leaderboard/${statType}?limit=5`)
      .then(res => res.json())
      .then(async (data) => {
        const leaderboard = data.leaderboard || [];
        const steamids = leaderboard.map(p => p.steamid64);
        await Promise.all([fetchAvatarsBulk(steamids), fetchCountriesBulk(steamids)]);
        setData(leaderboard);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [statType]);

  const formatValue = (value, type) => {
    if (type === 'kd') return value?.toFixed(2);
    if (type === 'headshots' || type === 'adr') return value?.toFixed(1);
    return formatNumber(value);
  };

  return (
    <div className="leaderboard-card">
      <div className="leaderboard-header">
        <span className="leaderboard-icon">{icon}</span>
        <h3>{title}</h3>
      </div>
      {loading ? (
        <div className="loading-skeleton">
          {[...Array(5)].map((_, i) => <div key={i} className="skeleton-row" />)}
        </div>
      ) : (
        <div className="leaderboard-list">
          {data.map((entry, index) => (
            <div
              key={entry.steamid64}
              className={`leaderboard-row clickable ${index === 0 ? 'top-player' : ''}`}
              onClick={() => onSelectPlayer && onSelectPlayer(entry.steamid64)}
            >
              <span className={`rank rank-${index + 1}`}>{index + 1}</span>
              <SteamAvatar steamid64={entry.steamid64} name={entry.name} size="small" />
              <SteamFlag steamid64={entry.steamid64} className="leaderboard-flag" />
              <span className="player-name">{entry.name}</span>
              <span className="player-stat">{formatValue(entry.value, statType)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Leaderboard;
